import * as React from 'react';
import { ChartBar, Gift, ArrowRight, ListChecks } from 'lucide-react';

interface ReportsCardProps {
  rewardsPath: string;
  rulesCount: number;
  badgesCount: number;
}

export function ReportsCard({
  rewardsPath,
  rulesCount,
  badgesCount,
}: ReportsCardProps) {
  return (
    <article className="loyalty-card">
      <header className="loyalty-card__header loyalty-card__header--stacked">
        <h2 className="loyalty-card__title">
          <ChartBar size={20} />
          Relatórios
        </h2>
        <p className="loyalty-card__description">
          Consulte o histórico de recompensas concedidas e valide se as regras
          estão gerando engajamento.
        </p>
      </header>
      <div className="loyalty-card__body">
        <div className="loyalty-report-grid">
          <div className="loyalty-report-stat">
            <div className="loyalty-report-stat__label">
              <ListChecks size={16} />
              Regras
            </div>
            <p className="loyalty-report-stat__value">{rulesCount}</p>
          </div>
          <div className="loyalty-report-stat">
            <div className="loyalty-report-stat__label">
              <Gift size={16} />
              Badges
            </div>
            <p className="loyalty-report-stat__value">{badgesCount}</p>
          </div>
        </div>
        <a href={rewardsPath} className="loyalty-button loyalty-button--secondary loyalty-button--full">
          <span className="loyalty-button__label">
            <Gift size={16} />
            Ver recompensas concedidas
          </span>
          <ArrowRight size={16} />
        </a>
      </div>
    </article>
  );
}
